<template>
  <div class="container mx-auto px-5 py-24">
    <div class="mx-auto max-w-2xl lg:text-center">
      <h2 class="text-base/7 font-semibold text-indigo-600">¡Estamos listos para ayudarte!</h2>
      <p
        class="mt-2 text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl lg:text-balance text-white"
      >
        ¿Listo para comenzar?
      </p>
      <p class="mt-6 text-lg/8 text-gray-600 text-white text-justify">
        Si estás preparado para dar el siguiente paso, estamos aquí para acompañarte. Ya sea que
        quieras saber más sobre nuestros servicios o empezar a trabajar juntos, contáctanos y nos
        aseguraremos de que tu experiencia sea increíble desde el primer momento.
      </p>
    </div>

    <div class="mx-auto md:w-2/3 lg:w-1/2 mt-16">
      <form @submit.prevent="handleSubmit" class="-m-2 flex flex-wrap">
        <div class="w-1/2 p-3">
          <div class="relative">
            <input
              v-model="formData.name"
              type="text"
              id="name"
              name="name"
              class="peer w-full rounded border border-gray-700 bg-gray-800 bg-opacity-40 py-1 px-3 text-base leading-8 text-gray-100 placeholder-transparent outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:bg-gray-900 focus:ring-2 focus:ring-indigo-900"
              :class="{ 'border-red-500': formErrors.name }"
              placeholder="Nombre"
            />
            <label
              for="Name"
              class="absolute left-3 -top-6 bg-transparent text-sm leading-7 text-indigo-500"
              >Nombre</label
            >
            <span v-if="formErrors.name" class="text-red-500 text-xs mt-1">{{
              formErrors.name
            }}</span>
          </div>
        </div>

        <div class="w-1/2 p-3">
          <div class="relative">
            <input
              v-model="formData.email"
              type="email"
              id="email"
              name="email"
              class="peer w-full rounded border border-gray-700 bg-gray-800 bg-opacity-40 py-1 px-3 text-base leading-8 text-gray-100 placeholder-transparent outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:bg-gray-900 focus:ring-2 focus:ring-indigo-900"
              :class="{ 'border-red-500': formErrors.email }"
              placeholder="email"
            />
            <label
              for="email"
              class="absolute left-3 -top-6 bg-transparent text-sm leading-7 text-indigo-500"
              >email</label
            >
            <span v-if="formErrors.email" class="text-red-500 text-xs mt-1">{{
              formErrors.email
            }}</span>
          </div>
        </div>

        <div class="w-full p-3">
          <div class="relative">
            <input
              v-model="formData.phone"
              type="tel"
              id="phone"
              name="phone"
              class="peer w-full rounded border border-gray-700 bg-gray-800 bg-opacity-40 py-1 px-3 text-base leading-8 text-gray-100 placeholder-transparent outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:bg-gray-900 focus:ring-2 focus:ring-indigo-900"
              :class="{ 'border-red-500': formErrors.phone }"
              placeholder="Teléfono"
            />
            <label
              for="phone"
              class="absolute left-3 -top-6 bg-transparent text-sm leading-7 text-indigo-500"
              >Teléfono</label
            >
            <span v-if="formErrors.phone" class="text-red-500 text-xs mt-1">{{
              formErrors.phone
            }}</span>
          </div>
        </div>

        <div class="w-full p-3">
          <div class="relative">
            <textarea
              v-model="formData.comment"
              id="comment"
              name="comment"
              class="peer h-32 w-full resize-none rounded border border-gray-700 bg-gray-800 bg-opacity-40 py-1 px-3 text-base leading-6 text-gray-100 placeholder-transparent outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:bg-gray-900 focus:ring-2 focus:ring-indigo-900"
              :class="{ 'border-red-500': formErrors.comment }"
              placeholder="Mensaje"
            ></textarea>
            <label
              for="comment"
              class="absolute left-3 -top-6 bg-transparent text-sm leading-7 text-indigo-500"
              >Mensaje</label
            >
            <span v-if="formErrors.comment" class="text-red-500 text-xs mt-1">{{
              formErrors.comment
            }}</span>
          </div>
        </div>

        <div class="w-full p-3">
          <div v-if="apiError" class="text-red-500 text-sm mb-4">{{ apiError }}</div>
          <button
            type="submit"
            :disabled="isSubmitting"
            class="mx-auto flex items-center rounded border-0 bg-indigo-500 py-2 px-8 text-lg text-white hover:bg-indigo-600 focus:outline-none disabled:opacity-50"
          >
            {{ isSubmitting ? "Enviando..." : "Enviar" }}
            <svg v-if="!isSubmitting" class="w-6 h-6 ml-2" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M12 2a1 1 0 0 1 .932.638l7 18a1 1 0 0 1-1.326 1.281L13 19.517V13a1 1 0 1 0-2 0v6.517l-5.606 2.402a1 1 0 0 1-1.326-1.281l7-18A1 1 0 0 1 12 2Z"
              />
            </svg>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { API_CREDENTIALS } from "../config/api";

export default {
  Name: "Contacto",
  data() {
    return {
      formData: {
        name: "",
        email: "",
        phone: "",
        comment: "",
      },
      formErrors: {
        name: "",
        email: "",
        phone: "",
        comment: "",
      },
      isSubmitting: false,
      apiError: null,
    };
  },
  methods: {
    created() {
      console.log("Variables de entorno:", {
        baseUrl: import.meta.env.VITE_API_BASE_URL,
        email: import.meta.env.VITE_API_EMAIL,
      });
    },
    validateForm() {
      console.log("Validando formulario con datos:", this.formData);
      let isValid = true;
      this.formErrors = {
        name: "",
        email: "",
        phone: "",
        comment: "",
      };

      if (!this.formData.name.trim()) {
        this.formErrors.name = "El nombre es requerido";
        isValid = false;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.formData.email)) {
        this.formErrors.email = "Email inválido";
        isValid = false;
      }

      // Validacion Telefono. debe tener 10 o 12 digitos.
      const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
      if (this.formData.phone && !phoneRegex.test(this.formData.phone)) {
        this.formErrors.phone = "Teléfono inválido";
        isValid = false;
      }

      if (!this.formData.comment.trim()) {
        this.formErrors.comment = "El mensaje es requerido";
        isValid = false;
      }

      return isValid;
    },

    async handleSubmit() {
      if (this.validateForm()) {
        try {
          console.log("Datos del formulario:", {
            Nombre: this.formData.name,
            Email: this.formData.email,
            Teléfono: this.formData.phone,
            Mensaje: this.formData.comment,
          });

          this.isSubmitting = true;
          this.apiError = null;

          const token = await this.getToken();
          console.log("Token obtenido:", token);

          const emailBody = {
            Name: this.formData.name,
            Email: this.formData.email,
            Phone: this.formData.phone,
            Comment: this.formData.comment,
          };

          console.log("Email body a enviar:", emailBody);

          const response = await fetch("https://webapi.optimuz.cl/WEBAPI/api/v2/email/send", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(emailBody),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.Comment || "Error al enviar el formulario");
          }

          this.formData = {
            name: "",
            email: "",
            phone: "",
            comment: "",
          };

          alert("¡Mensaje enviado con éxito!");
        } catch (error) {
          this.apiError = "Hubo un error al enviar el mensaje. Por favor, intenta nuevamente.";
          console.error("Error:", error);
        } finally {
          this.isSubmitting = false;
        }
      }
    },
    async getToken() {
      try {
        const response = await fetch("https://webapi.optimuz.cl/WEBAPI/api/v2/email/tokenjwt", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            email: API_CREDENTIALS.email,
            password: API_CREDENTIALS.password,
          }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.log("Error response:", errorData);
          throw new Error(errorData.message || "Error al obtener el token");
        }

        const data = await response.json();
        console.log("Token response:", data);
        return data.token;
      } catch (error) {
        console.error("Error detallado:", error);
        throw error;
      }
    },
  },
};
</script>
